import React, { useEffect, useState } from 'react';
import { Button, Form, Header, Message } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { API, isRoot } from '../helpers';

const endpoint = '/api/billing/v8/admin/commercial/receipt-pricing';

export default function OpenLuxPricingSettingV1012() {
  const { i18n } = useTranslation();
  const zh = (i18n?.language || 'zh').startsWith('zh');
  const [settings, setSettings] = useState(null);
  const [revision, setRevision] = useState(0);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);
  const root = isRoot();
  useEffect(() => {
    if (!root) return;
    let active = true;
    API.get(endpoint)
      .then(({ data }) => {
        if (!data.success) throw new Error(data.message);
        if (active) {
          setSettings(data.data.settings);
          setRevision(data.data.revision);
        }
      })
      .catch(
        () =>
          active && setError(zh ? '读取设置失败' : 'Unable to load settings')
      );
    return () => {
      active = false;
    };
  }, [root, zh]);
  if (!root) return null;
  const update = (key, value) => {
    setSaved(false);
    setSettings({ ...settings, [key]: value });
  };
  const save = async () => {
    setBusy(true);
    setError('');
    setSaved(false);
    try {
      const response = await API.put(
        endpoint,
        {
          revision,
          settings: {
            ...settings,
            receipt_wait_seconds: Number(settings.receipt_wait_seconds),
          },
        },
        {
          validateStatus: (status) =>
            status === 409 || (status >= 200 && status < 300),
        }
      );
      if (response?.status === 409) throw { response };
      const { data } = response;
      if (!data.success) throw new Error(data.message);
      setRevision(data.data.revision);
      setSaved(true);
    } catch (err) {
      setError(
        err.response?.status === 409
          ? zh
            ? '设置已被修改，请刷新后重试'
            : 'Settings changed. Refresh before saving.'
          : zh
          ? '保存失败，请检查倍率和等待时限'
          : 'Unable to save. Check the multiplier and waiting period.'
      );
    } finally {
      setBusy(false);
    }
  };
  return (
    <section style={{ maxWidth: 640 }}>
      <Header as='h3'>
        {zh ? 'OpenLux 回执结算' : 'OpenLux receipt settlement'}
      </Header>
      {error && <Message negative role='alert' content={error} />}
      {saved && (
        <Message positive role='status' content={zh ? '已保存' : 'Saved'} />
      )}
      {!settings ? (
        <span role='status'>{zh ? '加载中' : 'Loading'}</span>
      ) : (
        <Form onSubmit={save} loading={busy}>
          <Form.Input
            id='openlux-base-markup-v1012'
            label={
              zh
                ? '新价格版本的基准价加价倍率'
                : 'Base markup for new price versions'
            }
            type='number'
            min='0.000001'
            max='100'
            step='any'
            required
            value={settings.base_markup}
            onChange={(_, { value }) => update('base_markup', value)}
          />
          <Form.Input
            id='openlux-receipt-wait-v1012'
            label={
              zh ? '回执等待上限（秒）' : 'Receipt waiting limit (seconds)'
            }
            type='number'
            min='60'
            max='604800'
            step='1'
            required
            value={settings.receipt_wait_seconds}
            onChange={(_, { value }) => update('receipt_wait_seconds', value)}
          />
          <Button
            primary
            icon='save'
            content={zh ? '保存' : 'Save'}
            type='submit'
            disabled={busy}
          />
        </Form>
      )}
    </section>
  );
}
